<!--
  The card every Insights figure sits in: title, optional subtitle, action buttons, and the
  three states a CGS insight card has (loading, no data, data).

  `drillable` adds the "View the rows" button, which CGS shows as a database icon on each card.
  It emits `drill`, and the page decides what the drill-in shows, as CGS's emitter events did.
-->
<template>
  <section class="ins-card" :aria-busy="loading ? 'true' : 'false'" :aria-label="title">
    <div v-if="title || $slots.actions || drillable" class="ins-card__head">
      <div>
        <h2 v-if="title" class="ins-card__title">{{ title }}</h2>
        <p v-if="subtitle" class="ins-card__sub">{{ subtitle }}</p>
      </div>
      <div class="ins-card__actions">
        <slot name="actions" />
        <button v-if="drillable"
                type="button"
                class="ins-icon-btn"
                :disabled="loading || empty"
                :title="drillLabel"
                :aria-label="drillLabel"
                @click="$emit('drill')">
          <i class="fa-light fa-table-list"></i>
        </button>
      </div>
    </div>

    <div class="ins-card__body">
      <div v-if="loading" class="ins-skel" aria-hidden="true">
        <span v-for="n in skeletonRows" :key="n" :style="{ width: (92 - (n % 3) * 18) + '%' }"></span>
      </div>
      <div v-else-if="empty" class="ins-empty">{{ emptyText }}</div>
      <slot v-else />
    </div>
  </section>
</template>

<script>
export default {
  name: 'InsightCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    // CGS's wording, kept.
    emptyText: { type: String, default: 'No data for the selected date range.' },
    drillable: { type: Boolean, default: false },
    drillLabel: { type: String, default: 'View the rows behind this card' },
    skeletonRows: { type: Number, default: 5 }
  },
  emits: ['drill']
}
</script>
